<div class="wrapper">
    <div class="container px-0">
        <!-- <h5 class="main-title">{{patientpersonalinfo?.PracticeName}}</h5> -->
        <div class="row justify-content-center">
            <div class="col-md-6">
                <div class="card border">
                    <div class="card-body p-0 text-center">
                        <h5 class="bg-info font-weight-bold mb-0 p-3 text-white">Registered Successfully! 
                        </h5>
                        <p class="mb-0 p-3">
                            Thank you for registering with Madison Medical and Sports Rehab Center, we will be contacting you to set up a time for your visit. We look forward to seeing you in the office.</p>
                        <!-- <p class="mb-0 p-3" [innerHTML]="sanitizer.bypassSecurityTrustHtml(check_in_message)"></p> -->
                        <h5 class="bg-light font-weight-bold mb-0 p-3 text-info text-success">
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<footer class="p-3">
    <div class="container p-0">
      <div class="text-right">
        <!-- <a class="btn btn-outline-primary" type="button" (click)="backPage()">Back</a> -->
        <!-- <a class="btn btn-primary" type="button" (click)="RegistorPatient()">Next</a> -->
        <!-- <button type="button" id="closethankyou" (click)="finishClicked()" class="btn btn-primary" >Finish</button> -->
      </div>
    </div>
  </footer>
